import { ISpinnerDataInitialState } from "../../types/spinnerDatainterface";
import { SpinnerDataActionTypes, SpinnerDataActions } from "../actionTypes/spinnerDataActionTypes";

const initialState: ISpinnerDataInitialState = {
    gender: [],
    vehicleBodyType: [],
    fuelType: [],
    leadStatus: [],
    leadIndustry: [],
    leadSource: [],
    bloodGroup: [],
    maritalStatus: [],
    activityStatus: [],
    driverType: [],
    vehicleType: [],
    pickupRequestStatus: [],
    pickupSheetType: [],
    hrLeavesStatus: [],
    hrReportTypes:[],
    saleActivityType: [],
    activityTargetType: [],
    generalExpenseStatus: [],
    generalExpenseType: [],
    operationExpenseStatus: [],
    operationExpenseType: [],
    salesExpenseStatus: [],
    salesExpenseType: [],
    billingCycle: [],
    hrRegularizationStatus: [],
    awbPaymentMode: [],
    awbServiceMode: [],
    awbBookingType: [],
    awbOrderType: [],
    awbDimension: [],
    awbState: [],
    rateServiceMode: [],
    fleetFtlStatus: [],
    drsPlacementType: [],
    drsStatus: []
}

export default function spinnerDataReducer(state = initialState, action: SpinnerDataActionTypes) {
  switch (action.type) {
    case SpinnerDataActions.SET_SPINNER_DATA:
      return action.payload

    default:
      return state;
  }
}
